export default __webpack_public_path__ + "static/media/portfolio-hover-201.50d63280.jpg";